import {App} from "@vue/runtime-core";
import {
    Breadcrumb,
    Button,
    ConfigProvider,
    Form,
    Input,
    Layout,
    Modal,
    Spin,
    Table,
    Tree,
    Descriptions,
    Empty,
    Transfer,
    Dropdown,
    Menu,
    Space,
    Select,
    DatePicker,
    Switch,
    Checkbox,
    Radio,
    Avatar,
    Tabs,
    Pagination,
    Upload,
    Row,
    Col,
    Steps,
    InputNumber,
    Image,
    Tag,
    Result,
    Card,
    Typography,
    TimePicker,
    Popover,
    Divider,
    Comment,
    TreeSelect,
    Statistic,
    Calendar,
    Badge,
    Carousel,
    Progress,
} from "ant-design-vue";


const antFactory = {
    init(app: App) {
        app.use(Button)
            .use(Input)
            .use(Spin)
            .use(Layout)
            .use(Breadcrumb)
            .use(Table)
            .use(ConfigProvider)
            .use(Modal)
            .use(Transfer)
            .use(Tree)
            .use(Space)
            .use(Select)
            .use(DatePicker)
            .use(Switch)
            .use(Checkbox)
            .use(Radio)
            .use(Dropdown)
            .use(Menu)
            .use(Avatar)
            .use(Pagination)
            .use(Tabs)
            .use(Upload)
            .use(Row)
            .use(Col)
            .use(Steps)
            .use(InputNumber)
            .use(Image)
            .use(Form)
            .use(Descriptions)
            .use(Tag)
            .use(Result)
            .use(Typography)
            .use(Card)
            .use(Tree)
            .use(TimePicker)
            .use(Popover)
            .use(Comment)
            .use(TreeSelect)
            .use(Divider)
            .use(Statistic)
            .use(Calendar)
            .use(Badge)
            .use(Carousel)
            .use(Progress)

        app.component('a-empty',Empty)
    }

}

export default antFactory;
